<div>
  <div class="login-form-cotainer  row">
    <div class="column small-12 medium-6 large-5 medium-centered">
      <div class="form">
        <header>
          <div class="logo" [ngStyle]="logoBg">
          </div>
          <h6 style="text-align: center;margin-top: 10px">Welcome, Please update your password.</h6>
        </header>
        <div class="row">
          <div class="small-12 columns ">
            <input type="password" placeholder="New Password *" [(ngModel)]="password">
          </div>
          <div class="small-12 columns ">
            <input type="password" placeholder="Confirm Password *" [(ngModel)]="confirmPassword">
          </div>
          <div *ngIf="notValid" class="small-12 columns" class="error" style="text-align: center">
            Password and confirm should match
          </div>
        </div>
        <div class="row align-middle">
          <div class="small-6 column">
            <button type="submit" style="border: none !important;padding: .85em 1em !important;font-size: 0.75rem !important;" class="button button-style" (click)="submit($event)">UPDATE
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
